import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { EditAdminComponent } from './edit-admin/edit-admin.component';
import { MatDialogCloseEvent, PageKey } from '../../../const';
import { PageEvent } from '@angular/material/paginator';
import { MatAccountService } from '../../mat-account/mat-account.service';
import { ToastrService } from 'ngx-toastr';
import { DtoClientAdmin, Pagination } from '../../../models/mat-account.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';
import { SharedService } from '../../../shared/services/shared.service';
import { SchoolService } from '../../school/school.service';
import { Role, RolePayload } from '../../../models/role.model';
import { RoleMaster } from '../user-role/user-role.component';
import { OpenedFromType } from '../../package-center/package/package.component';
import { ConfirmDialogComponent } from '../../mat-account/confirm-dialog/confirm-dialog.component';
import { timer } from 'rxjs';
import { PackageService } from '../../package-center/package/package.service';
import { SearchService } from '../../common/search.service';

export enum Tabs { AdminDetails = "Admin Details", Schools = "Schools", Package = "Package", Role = "Role", Users = "Users", Features="Features" } 

@Component({
  selector: 'app-admin-details',
  templateUrl: './admin-details.component.html',
})
export class AdminDetailsComponent implements OnInit {
  schoolName: string = "";
  index: number | undefined;
  userRole: string[] = [];
  roles = RoleMaster;
  totalRecords: number = 0;
  userEmail: string = "";
  matAdminList: DtoClientAdmin[] = [];
  sortFirstNameAsc: boolean = true;
  sortLastNameAsc: boolean = true;
  sortEmailIdAsc: boolean = true;
  sortCountryCodeAsc: boolean = true;
  searchTerm: string = "";
  pageKey = PageKey.MatAdminDetailsCenter;
  pageSize:number = 10;
  pageNumber:number = 0;
  pageOffSet:number = 0;
  clientAccountId: number = 0;
  roleName: string[] = [];
  clientAccountName: string = "";
  tabs = Tabs;
  activeTab: string = this.tabs.Role;
  createTriggered: boolean = false;
  searchTriggered: boolean = false;
  assignedPackageId: number = 0;
  hideHeader: boolean = false;
  openedFromIndependentSchool: boolean = false;
  schoolId: number = 0;
  hideCreate: boolean = false;
  roleData: Role[] = [];
  openedFromType: number = 0;
  numberOfUsersToAllow: number = 0;
  createText: string = "";
  goBackToSchoolList: number = 2;
  sortColumn: string = "";
  sortDirection: string = "";

  constructor( private dialog: MatDialog, private route: ActivatedRoute, private matAccountService: MatAccountService,
               private toasterService: ToastrService, private router: Router, private sharedService: SharedService,
               private schoolService: SchoolService, private packageService: PackageService, private readonly searchService: SearchService
  ) {}
  ngOnInit() {
    this.userEmail = sessionStorage.getItem('user_email')!;
    this.userRole = sessionStorage.getItem('user_role')?.split(',')!;
    this.userRole?.forEach(element => {
      this.roleName.push(this.getRoleNameByValue(RoleMaster, element)!);
    });
    if(this.userRole?.includes(this.roles.MatAdmin)){
      this.searchTerm = this.searchService.getSearchTerm(this.pageKey);
      this.activeTab = this.tabs.AdminDetails;
      this.getClientAdminDetails();
      return;
    }
    this.route.queryParams.subscribe((params) => {
      this.clientAccountId = params['clientAccountId'];
      this.clientAccountName = params['clientAccountName'];
      this.assignedPackageId = params['packageId'];
      this.openedFromIndependentSchool = params['independentSchoolData'] == 1;
      if(this.openedFromIndependentSchool)
        this.activeTab = this.tabs.Users;
      else
        this.activeTab = this.tabs.Schools;

      this.schoolId = params['schoolId'];
      this.schoolName = params['schoolName'];
      this.numberOfUsersToAllow = params['numberOfUsersToAllow'];

      if(this.clientAccountId > 0){
        this.getClientAdminDetails();
      }
      if(this.assignedPackageId > 0){
        this.sharedService.setAssignedPackageId(this.assignedPackageId);      
      }
    });
    this.openedFromType = this.userRole.includes(this.roles.SuperAdmin) || this.userRole.includes(this.roles.AccountAdmin) ?
                          OpenedFromType.RequestToChangeAdmin : OpenedFromType.RequestToChangePackage;
  }
  
  getRoles(clientAccountId: number, payload = {} as Pagination) {
    let rolePayload = {
      isIndividualEntity : clientAccountId == 0,
      clientAccountId : clientAccountId > 0 ? [this.clientAccountId] : [this.schoolId],
      pagination: payload
    } as RolePayload;
    this.schoolService.getRoles(rolePayload).subscribe((response: Role[] | any) => {
    //this.schoolService.getRoles(clientAccountId, payload).subscribe((response: Role[] | any) => {
      this.roleData = response;
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    });
  }

  showSchoolDetails(value: boolean){
    this.createTriggered = value;
    this.hideHeader = value;
    this.activeTab = this.tabs.Schools;
  }

  async onCreate(): Promise<any>{
    this.createTriggered = true;
    if(this.activeTab == this.tabs.AdminDetails){
      if(this.matAdminList.length>0 && this.matAdminList[0].numberOfClientAdmin <= this.matAdminList.length){
        this.toasterService.error("Maximum number of client admins for this account has already been created");
        return;
      }
      try {
        //Check if subscription is available to add another admin
        let numberOfSubscriptionAvailable = await this.packageService.getAvailableSubscriptionForPackage(this.assignedPackageId);
        if(numberOfSubscriptionAvailable < 1) {
          this.toasterService.error("Package has exceeded the maximum number of subscriptions");
          return;
        }
      }
      catch (errorResponse: any) {
        this.toasterService.error(errorResponse.error, 'Error');
        return;
      }
      this.openEditModal();
      return;
    }
    if(this.activeTab == this.tabs.Schools){
      this.hideHeader = !this.hideCreate;
    }
  }
  
  onChangePackage(){
    this.openedFromType = OpenedFromType.SwapPackageForAdmin;
  }

  
  setActiveTab(tabName: string){
    if(tabName == Tabs.Users){
      this.getRoles(this.clientAccountId);
    }
    this.activeTab = tabName;
    this.schoolName = this.openedFromIndependentSchool ? this.schoolName : "";
    this.searchService.setSearchTerm(this.pageKey, "");
    this.searchTerm = "";
    if(tabName == Tabs.AdminDetails){
      this.getClientAdminDetails();
    }
    this.createTriggered = false;
    this.hideCreate = false;
  }

  getRoleNameByValue<T extends { [index: string]: string }>(
    enumObj: T,
    value: string
  ): string | undefined {
    const keys = Object.keys(enumObj).filter((x) => enumObj[x] === value);
    return keys.length > 0 ? keys[0] : undefined;
  }

  ViewDocument(data: DtoClientAdmin){
    if(!data.document.length){
      this.toasterService.warning("No attachment found");
      return;
    }
    this.dialog.open(ConfirmDialogComponent, {
      width: '675px',
      data: {
        hideUpload: true,
        files: data.document// Pass files to the dialog
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.doc){
        data.document = popupEvent.doc;
      }
    });
  }

  getClientAdminDetails(sortColumn = "", sortDirection = ""){
    this.searchService.setSearchTerm(this.pageKey, this.searchTerm);
    let payload: Pagination = {} as Pagination;
    if(this.userRole?.includes(this.roles.MatAdmin)){
      payload.userEmail = this.userEmail;
    }
    if(sortColumn){
      this.sortColumn = sortColumn;
      this.sortDirection = sortDirection;
    }
      payload.sortColumn = this.sortColumn.charAt(0).toUpperCase() + this.sortColumn.slice(1);
      payload.sortDirection = this.sortDirection;
      payload.pageOffset = this.pageOffSet;
      payload.pageSize = this.pageSize;
      payload.searchTerm = this.searchTerm ? this.searchTerm.trim() : "";
    this.matAccountService.getMatAdminInformation(payload ,this.clientAccountId).subscribe((data: DtoClientAdmin[] | any) => {
      if(data){
        this.matAdminList = data;
        this.totalRecords = data.length ? parseInt(data[0].totalRecords) : 0;
        if(this.matAdminList.length && this.matAdminList[0].assignedPackageId > 0){
          this.sharedService.setAssignedPackageId(this.matAdminList[0].assignedPackageId);
        }
      }
    },(err: HttpErrorResponse)=>{
      if(err.error){
        this.toasterService.error(err.error, "Error");
      }
    })
  }

  showCreate(){
    if(this.activeTab == Tabs.Schools && !this.hideCreate){
      this.createText = "Create School";
      return true;
    }
    //else if(this.activeTab == Tabs.Users){
    else if((this.activeTab == Tabs.Schools && this.hideCreate) || this.activeTab == Tabs.Users){
      this.createText = "Create School User";
      return true;
    }
    else if(this.activeTab == Tabs.Role){
      this.createText = "Create Audience";
      return true;
    }
    else if(this.activeTab == Tabs.AdminDetails && !this.userRole.includes(this.roles.MatAdmin)){
      this.createText = "Create Admin";
      return true;
    }
    else if(this.activeTab == Tabs.Package && this.userRole.includes(this.roles.SuperAdmin)){
      this.createText = "Create Package";
      return true;
    }
    else{
      return false;
    }
  }

  onSearch(){
    if(this.activeTab == Tabs.AdminDetails){
      this.getClientAdminDetails();
    }
    if((this.activeTab == Tabs.Schools && this.hideCreate) || this.activeTab == Tabs.Users){
      this.searchTriggered = true;
    }
  }

  goBack(){
    if(this.openedFromIndependentSchool){
      this.router.navigate(['/independentSchool']);
    }
    else{
      this.router.navigate(['/userCenter']);
    }
  }

  changePage(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageNumber = event.pageIndex;
    this.pageOffSet = this.pageNumber * this.pageSize;
    this.getClientAdminDetails();
  }

  openEditModal(data: DtoClientAdmin = {} as DtoClientAdmin) {
    data.clientAccountId = this.clientAccountId;
    data.assignedPackageId = this.assignedPackageId;
    const numberOfClientAdminsDifference = 
      this.matAdminList.length==0?0:(
      this.matAdminList[0].numberOfClientAdmin - this.matAdminList.length);

    this.dialog.open(EditAdminComponent, {
      width: '1000px',
      data: data.emailId ? data : { clientAccountId: this.clientAccountId, numberOfClientAdminsDifference }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        timer(1000).subscribe(() => {
          this.getClientAdminDetails();
        });
      }
    });
  }

  updateTitle(schoolName: string){
    this.schoolName = schoolName;
  }
  
  deleteMatAdmin(data: DtoClientAdmin){
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to delete the MAT admin?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if(popupEvent?.event == MatDialogCloseEvent.SUCCESS){
        this.matAccountService.deleteMatAdmin(data.clientAdminId).subscribe((res)=>{
          if(res){
            this.toasterService.success("MAT admin deleted successfully!","Success");
            this.getClientAdminDetails();
          }
        },(error: HttpErrorResponse)=>{
          if(error.error){
            this.toasterService.error(error.error, "Error");
          }
        })
      }
    });
  }

  onTransferSchool() {
    this.router.navigate(['/transferSchool'], { state: 
      { 
        clientAccountId: this.clientAccountId, 
        clientAccountName: this.clientAccountName, 
        packageId: this.assignedPackageId,
        independentSchoolData: this.openedFromIndependentSchool, 
        schoolId: this.schoolId, 
        schoolName: this.schoolName, 
        numberOfUsersToAllow: this.numberOfUsersToAllow
      } 
    })
  }
}
